module.exports = __webpack_public_path__ + "static/img/paint.ab17aef0.svg";